var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.className},[_c('span',{ref:"inner",staticClass:"o-cursor__inner",style:(_vm.color)},[_c('span',{ref:"content",staticClass:"o-cursor__content"},[(_vm.label)?_c('span',{ref:"label",staticClass:"o-cursor__label | t-sub"},[_vm._v("\n                "+_vm._s(_vm.label)+"\n            ")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }